import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4616af7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "uploading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uk-icon-spinner uk-icon-spin" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "click-to-upload" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Update")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "company-logo-wrapper",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.fileInput.click()))
  }, [
    _createElementVNode("img", {
      src: _ctx.src,
      class: "logo",
      alt: "Logo"
    }, null, 8, _hoisted_1),
    _createElementVNode("input", {
      ref: "fileInput",
      accept: "image/x-png,image/gif,image/jpeg",
      class: "file-input",
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
    }, null, 544),
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5
  ]))
}